/**
 * Created by fers on 10.05.16.
 */
import {injectIntl} from 'react-intl';

import HTMLTemplate from './system/HTMLTemplate.react.js';
import JSONTableNew from './system/JSONTableNew.react';
import JSONDetail from './system/JSONDetail.js';
import GoogleMap from './google/GoogleMap.react';
import GoogleDrive from './google/GoogleDrive.react';
import AddRelation from './apps/AddRelation.react';
import IFrame from './apps/IFrame.react';
import MailChimp from './mailchimp/MailChimp.react';
import Notes from './apps/Notes.react';
import CreditCheck from './CreditCheck.react';
import LogoBox from './LogoBox.react';
import Firmo from './firmo/Firmo.react.js';
import Merk from './merk/Merk.react.js';
import MerkFinancial from './merk/MerkFinancial.react.js';
import MerkContact from './merk/MerkContact.react.js';
import FullContact from './FullContact.react.js';
import BigContact from './BigContact.react.js';
import ZelenaPosta from './ZelenaPosta.react';
import EmailCheckHippo from './emailCheck/EmailCheckHippo.react';
import BasicEmailCheck from './BasicEmailCheck.react';
import ClearbitInfo from './ClearbitInfo.react';
import JSAction from './apps/JSAction.react';
import VatValidation from './VatValidation.react';


let handlers = [
    AddRelation,
    CreditCheck,
    Firmo,
    FullContact,
    BigContact,
    GoogleMap,
    GoogleDrive,
    HTMLTemplate,
	JSONTableNew,
    JSONDetail,
    LogoBox,
    MerkContact,
    Merk,
    MerkFinancial,
    ZelenaPosta,
    IFrame,
    JSAction,
    Notes,
    MailChimp,
    EmailCheckHippo,
    BasicEmailCheck,
    ClearbitInfo,
    VatValidation
];

let handlerMap = {};

for (let handler of handlers) {

	let handlerName = handler.handlerName;
	if ('WrappedComponent' in handler) {
		throw new Error('Handles are injected Intl by default, don\'t do it for handler separately!');
	}

    handlerMap[handlerName] = {
        value: handlerName,
        handler: injectIntl(handler)
    };
}

export default handlerMap;
